import Vue from 'vue';
import VueRouter from 'vue-router';

// Dashboard Components
import Dashboard from '../views/homepage/homepage.vue';
import ManageAuction from '../views/auction-manage/auction-manage.vue';
import ManageUser from '../views/users/manage/manage.vue';
import AuctionsList from '../views/auctions/list/list.vue';
import AuctionsAdd from '../views/auctions/add/add.vue';
import LiveAuction from '../views/auction-live/auction-live.vue';
import Depositors from '../views/depositors/list/list.vue';
import DepositorsAdd from '../views/depositors/add/add.vue';
import DepositorsManage from '../views/depositors/manage/manage.vue';
import PostBids from '../views/post-bids/post-bids.vue';
import UsersVerification from '../views/users/verifications/verifications.vue';
import UsersList from '../views/users/list/list.vue';
import StatisticsLive from '../views/statistics/live/list.vue';
import CertificatesList from '../views/certificates/list/list.vue';
import CertificatesAdd from '../views/certificates/add/add.vue';
import CertificatesManage from '../views/certificates/manage/manage.vue';
import SlidesList from '../views/slides/list/list.vue';
import SlidesAdd from '../views/slides/add/add.vue';
import SlidesManage from '../views/slides/manage/manage.vue';
import BlogList from '../views/blog/list/list.vue';
import BlogAdd from '../views/blog/add/add.vue';
import BlogManage from '../views/blog/manage/manage.vue';
import StockList from '../views/stock/list/list.vue';
import StockLot from '../views/stock/lot/lot.vue';
import StockLabels from '../views/stock/labels/labels.vue';
import StockScan from '../views/stock/scan/scan.vue';

import { storedUser, isStockOnly } from '../utils/access';

// Sample Pages
import error404 from '../views/sample-pages/error-404.vue';
import error500 from '../views/sample-pages/error-500.vue';

Vue.use(VueRouter);

const router = new VueRouter({
    routes: [
        {
            path: '/',
            component: Dashboard,
        },
        {
            path: '/auctions',
            component: AuctionsList,
        },
        {
            path: '/auctions/add',
            component: AuctionsAdd,
        },
        {
            path: '/auctions/manage/:id',
            component: ManageAuction,
        },
        {
            path: '/auctions/live/:id',
            component: LiveAuction,
        },
        {
            path: '/depositors',
            component: Depositors,
        },
        {
            path: '/depositors/add',
            component: DepositorsAdd,
        },
        {
            path: '/depositors/manage/:id',
            component: DepositorsManage,
        },
        {
            path: '/certificates',
            component: CertificatesList,
        },
        {
            path: '/certificates/add',
            component: CertificatesAdd,
        },
        {
            path: '/certificates/manage/:id',
            component: CertificatesManage,
        },
        {
            path: '/slides',
            component: SlidesList,
        },
        {
            path: '/slides/add',
            component: SlidesAdd,
        },
        {
            path: '/slides/manage/:id',
            component: SlidesManage,
        },
        {
            path: '/blog',
            component: BlogList,
        },
        {
            path: '/blog/add',
            component: BlogAdd,
        },
        {
            path: '/blog/manage/:id',
            component: BlogManage,
        },
        {
            path: '/stocuri',
            component: StockList,
        },
        {
            path: '/stocuri/lot/:sku',
            component: StockLot,
        },
        {
            path: '/stocuri/scanare',
            component: StockScan,
        },
        {
            path: '/etichete',
            component: StockLabels,
        },
        {
            path: '/users',
            component: UsersList,
        },
        {
            path: '/users/verifications',
            component: UsersVerification,
        },
        {
            path: '/users/manage/:id',
            component: ManageUser,
        },
        {
            path: '/statistics/live',
            component: StatisticsLive,
        },
        {
            path: '/post-bids',
            component: PostBids,
        },
        {
            path: '/500',
            component: error500,
        },
        {
            path: '*',
            component: error404,
        },
    ],
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    mode: 'history',
    linkActiveClass: 'active',
});

// Rutele in care are voie un cont de gestionar de depozit (hasStockAccess
// fara isAdmin).
const STOCK_ONLY_PATHS = ['/stocuri', '/etichete'];

router.beforeEach((to, from, next) => {
    // Codul QR de pe eticheta duce la `/?stoc=<sku>`. Adminul este servit
    // static dintr-un bucket, unde doar radacina e garantat rezolvabila -
    // asa ca rescriem aici catre ruta reala. Ruleaza si inainte de login,
    // deci dupa autentificare utilizatorul ajunge direct pe lot.
    if (to.path === '/' && to.query.stoc) {
        return next('/stocuri/lot/' + to.query.stoc);
    }

    const user = storedUser();

    if (user && user.hasBlogOnlyAccess && !to.path.startsWith('/blog')) {
        return next('/blog');
    }

    if (
        isStockOnly(user) &&
        !STOCK_ONLY_PATHS.some(path => to.path.startsWith(path))
    ) {
        return next('/stocuri');
    }

    next();
});

export default router;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/router/index.ts